import {Box} from "@material-ui/core";
import React from "react";

export const ToolbarFiller = () => (
    <Box flex="1 1 auto"/>
)